export function isDaytime() {
  const dayStart = new Date().setHours(6, 0, 0, 0);
  const dayEnd = new Date().setHours(20, 0, 0, 0);
  const timestamp = new Date().getTime();
  return timestamp >= dayStart && timestamp <= dayEnd;
}

export function getDayNightBackgroundSource() {
  return isDaytime()
    ? require('../assets/header-image-background-day.png')
    : require('../assets/header-image-background-night.png');
}
